import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorder} from "../TheBorder";
import {TheBorderGameAssets} from "../TheBorderGameAssets";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {gsap} from "gsap";

export class TheBorderXRipBlastView extends PIXI.Container implements StageLayer {
    private _xRipBlast: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "TheBorderXRipBlast";
        this.init();
        this.onResize();
    }

    public playBlast(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                this._xRipBlast.visible = false;
                this._xRipBlast.state.clearTracks();
            }
        });

        tl.add(() => {
            if (!this._xRipBlast.visible) {
                this._xRipBlast.visible = true;
                this._xRipBlast.updateTransform();
            }
            this._xRipBlast.state.clearTracks();
            this._xRipBlast.skeleton.setSlotsToSetupPose();
            this._xRipBlast.skeleton.setToSetupPose();
            this._xRipBlast.state.setEmptyAnimation(0, 0);
        });
        tl.add(new SpineTween(this._xRipBlast, 0, "animation"));

        return tl;
    }

    public onResize(): void {
        // these calculations are copied from slot-keypad
        const bounds: ScreenBounds = NolimitApplication.screenBounds,
            edgeMarginX: number = 10,
            edgeMarginY: number = 10,
            balanceHeight: number = 26,
            labelBottomEdgeMargin: number = edgeMarginY - 7,
            xOffsetPortrait: number = 50;

        if (NolimitApplication.isLandscape) {
            this._xRipBlast.position.set(bounds.center, bounds.bottom - labelBottomEdgeMargin);
        } else {
            this._xRipBlast.position.set(bounds.right - edgeMarginX - xOffsetPortrait, bounds.bottom - labelBottomEdgeMargin - balanceHeight - edgeMarginY + 3 - labelBottomEdgeMargin);
        }
    }

    private init(): void {
        this._xRipBlast = new PIXI.spine.Spine(TheBorder.assetLoader.getSpineAsset(TheBorderGameAssets.X_RIP_BLAST));
        this._xRipBlast.visible = false;

        this.addChild(this._xRipBlast);
    }
}